var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-wrap boss-main-content-wrap" }, [
    _vm.reservations.length
      ? _c("table", { staticClass: "unstriped hover boss-table" }, [
          _c("thead", [
            _c(
              "tr",
              [
                _c(
                  "th",
                  {
                    staticClass:
                      "boss-table-head-center pega-reservation-name-width",
                  },
                  [_vm._v("\n          予約名\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "boss-table-head-center pega-reservation-subject-width",
                  },
                  [_vm._v("\n          件名\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "boss-table-head-center pega-reservation-favor-width",
                  },
                  [_vm._v("\n          スカウト特典\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "boss-table-head-center pega-reservation-send-width",
                  },
                  [_vm._v("\n          送信開始予定\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "boss-table-head-center pega-reservation-status-width",
                  },
                  [_vm._v("\n          送信状況\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "boss-table-head-center pega-reservation-target-width",
                  },
                  [_vm._v("\n          対象(送信完了/送信対象)\n        ")]
                ),
                _vm._v(" "),
                _vm.isSendScout
                  ? [
                      _c(
                        "th",
                        {
                          staticClass: "boss-table-head-center boss-operation",
                        },
                        [_vm._v("\n            編集\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "boss-table-head-center boss-operation",
                        },
                        [_vm._v("\n            削除\n          ")]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.reservations, function (reservation) {
              return _c("scout-reservation-outline", {
                key: reservation.id,
                attrs: {
                  "contract-id": Number(_vm.$route.params.contractId),
                  "job-id": Number(_vm.$route.params.jobId),
                  reservation: reservation,
                  "show-edit": _vm.isSendScout,
                },
                on: { fetch: _vm.fetchReservations },
              })
            }),
            1
          ),
        ])
      : _c(
          "div",
          {
            staticClass: "grid-x grid-margin-y align-center margin-top-2",
            attrs: { "data-test": "no-reservation" },
          },
          [
            _c("span", { staticClass: "cell medium-4 subheader text-center" }, [
              _vm._v("スカウト送信予約がありません。"),
            ]),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }